function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from 'react';
import './notification-action-builder.scss';
import { getDomainDefaultActionLabels, getClassNames } from '../../utils';
import { CloseCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Input, Select, Switch } from 'antd';
import { NotificationAction } from '@pushly/models/lib/structs/notification-action';
import { MacroManager } from '../macro-manager/macro-manager';
import EmojiManager from '../emoji-manager/emoji-manager';
import { NotificationActionType } from '@pushly/models/lib/enums/notification-action-type';
export var NotificationActionBuilder = /*#__PURE__*/function (_React$Component) {
  _inherits(NotificationActionBuilder, _React$Component);

  var _super = _createSuper(NotificationActionBuilder);

  function NotificationActionBuilder(props) {
    var _this;

    _classCallCheck(this, NotificationActionBuilder);

    _this = _super.call(this, props);

    _this.handleActionChange = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(action) {
        var _this$props$onChange, _this$props;

        var update, domain, domainDefaultLabels, _this$props$rootActio, siblingAction;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                update = _this.currentAction;
                update.setType(action);
                domain = _this.props.domain;
                domainDefaultLabels = getDomainDefaultActionLabels(domain);

                if (update.type === NotificationActionType.CLOSE) {
                  update.setLabel(domainDefaultLabels.close).setLandingUrl(undefined).setUsePrimaryLandingUrl(undefined);
                } else {
                  siblingAction = (_this$props$rootActio = _this.props.rootActions) === null || _this$props$rootActio === void 0 ? void 0 : _this$props$rootActio.find(function (a) {
                    return a.ordinal !== update.ordinal;
                  });
                  update.setLabel(domainDefaultLabels.openUrl).setUsePrimaryLandingUrl(!siblingAction || siblingAction.type === NotificationActionType.CLOSE || !siblingAction.usePrimaryLandingUrl);
                }

                (_this$props$onChange = (_this$props = _this.props).onChange) === null || _this$props$onChange === void 0 ? void 0 : _this$props$onChange.call(_this$props, update);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleLabelChange = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ev) {
        var _this$props$onChange2, _this$props2;

        var update;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                update = _this.currentAction;
                update.setLabel(ev.target.value);
                (_this$props$onChange2 = (_this$props2 = _this.props).onChange) === null || _this$props$onChange2 === void 0 ? void 0 : _this$props$onChange2.call(_this$props2, update);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.handleLandingUrlChange = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(ev) {
        var _this$props$onChange3, _this$props3;

        var update;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                update = _this.currentAction;
                update.setLandingUrl(ev.target.value);
                (_this$props$onChange3 = (_this$props3 = _this.props).onChange) === null || _this$props$onChange3 === void 0 ? void 0 : _this$props$onChange3.call(_this$props3, update);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.setUsePrimaryLandingUrl = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(usePrimaryLandingUrl) {
        var _this$props$onChange4, _this$props4;

        var update;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                update = _this.currentAction;
                update.setUsePrimaryLandingUrl(usePrimaryLandingUrl);

                if (usePrimaryLandingUrl) {
                  update.setLandingUrl(_this.props.primaryLandingUrl);
                } else {
                  update.setLandingUrl(undefined);
                }

                (_this$props$onChange4 = (_this$props4 = _this.props).onChange) === null || _this$props$onChange4 === void 0 ? void 0 : _this$props$onChange4.call(_this$props4, update);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.handleAdd = function () {
      var _this$props$rootActio2, _this$props$rootActio3, _this$props$onAdd, _this$props5;

      var domain = _this.props.domain;
      var domainDefaultLabels = getDomainDefaultActionLabels(domain);
      var nextOrdinal = ((_this$props$rootActio2 = _this.props.rootActions) !== null && _this$props$rootActio2 !== void 0 ? _this$props$rootActio2 : []).length;
      var siblingAction = (_this$props$rootActio3 = _this.props.rootActions) === null || _this$props$rootActio3 === void 0 ? void 0 : _this$props$rootActio3[0];
      (_this$props$onAdd = (_this$props5 = _this.props).onAdd) === null || _this$props$onAdd === void 0 ? void 0 : _this$props$onAdd.call(_this$props5, NotificationAction.Builder.setType(NotificationActionType.OPEN_URL).setOrdinal(nextOrdinal).setLabel(domainDefaultLabels.openUrl).setLandingUrl(undefined).setUsePrimaryLandingUrl(!siblingAction || siblingAction.type === NotificationActionType.CLOSE || !siblingAction.usePrimaryLandingUrl));
    };

    _this.handleRemove = function () {
      var _this$props$onRemove, _this$props6, _this$props$config;

      (_this$props$onRemove = (_this$props6 = _this.props).onRemove) === null || _this$props$onRemove === void 0 ? void 0 : _this$props$onRemove.call(_this$props6, (_this$props$config = _this.props.config) !== null && _this$props$config !== void 0 ? _this$props$config : {});
    };

    return _this;
  }

  _createClass(NotificationActionBuilder, [{
    key: "render",
    value: function render() {
      var _this$props$config2, _this$props$config3, _config$displayMeta, _this$props$macroType, _config$ordinal, _getClassNames, _this$props$addAction, _this$props$addAction2, _this$props$noActionT, _this$props$removeLab, _this$props$config4;

      var domain = this.props.domain;
      var domainDefaultLabels = getDomainDefaultActionLabels(domain);
      var _this$props7 = this.props,
          mode = _this$props7.mode,
          enabled = _this$props7.enabled,
          title = _this$props7.title,
          hidePrimaryLandingUrl = _this$props7.hidePrimaryLandingUrl,
          removable = _this$props7.removable;
      var config = (_this$props$config2 = this.props.config) !== null && _this$props$config2 !== void 0 ? _this$props$config2 : NotificationAction.Builder;
      var isStaticMode = mode === 'static';
      var actionType = config.type || NotificationActionType.OPEN_URL;
      var isOpenUrlAction = actionType === NotificationActionType.OPEN_URL;
      var isCloseAction = actionType === NotificationActionType.CLOSE;
      var usePrimaryLandingUrl = config.usePrimaryLandingUrl;
      var landingUrlValue = config.landingUrl;
      var defaultLabelValue = isOpenUrlAction ? domainDefaultLabels.openUrl : domainDefaultLabels.close;
      var labelValue = ((_this$props$config3 = this.props.config) === null || _this$props$config3 === void 0 ? void 0 : _this$props$config3.label) || defaultLabelValue;
      var eid = (_config$displayMeta = config.displayMeta) === null || _config$displayMeta === void 0 ? void 0 : _config$displayMeta.eid;
      var rootActions = this.props.rootActions || [];

      var _match = function _match(action, type) {
        var _action$displayMeta;

        return ((_action$displayMeta = action.displayMeta) === null || _action$displayMeta === void 0 ? void 0 : _action$displayMeta.eid) !== eid && action.type === type;
      };

      var disableCloseSelection = !!rootActions.find(function (a) {
        return _match(a, NotificationActionType.CLOSE);
      });
      var disablePrimaryLandingUrl = !!rootActions.find(function (a) {
        return _match(a, NotificationActionType.OPEN_URL) && a.usePrimaryLandingUrl;
      });
      var macroTypes = (_this$props$macroType = this.props.macroTypes) !== null && _this$props$macroType !== void 0 ? _this$props$macroType : ['domain', 'device', 'location', 'notification', 'custom']; // domain macros should only be visible on URL fields

      var labelSafeMacroTypes = macroTypes.filter(function (type) {
        return type !== 'domain' && type !== 'device';
      });
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: getClassNames('notif-action-builder', (_getClassNames = {}, _defineProperty(_getClassNames, "action-".concat(((_config$ordinal = config.ordinal) !== null && _config$ordinal !== void 0 ? _config$ordinal : 0) + 1), true), _defineProperty(_getClassNames, 'mode-static', isStaticMode), _getClassNames))
      }, /*#__PURE__*/React.createElement("div", {
        className: getClassNames('notif-action-builder-wrapper')
      }, !enabled ? /*#__PURE__*/React.createElement("div", {
        className: getClassNames('notif-action-add'),
        onClick: this.handleAdd
      }, !isStaticMode ? /*#__PURE__*/React.createElement(React.Fragment, null, (_this$props$addAction = this.props.addActionIcon) !== null && _this$props$addAction !== void 0 ? _this$props$addAction : /*#__PURE__*/React.createElement(PlusOutlined, null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, (_this$props$addAction2 = this.props.addActionText) !== null && _this$props$addAction2 !== void 0 ? _this$props$addAction2 : 'Add Button'))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, (_this$props$noActionT = this.props.noActionText) !== null && _this$props$noActionT !== void 0 ? _this$props$noActionT : 'Button not enabled'))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: getClassNames('notif-action-ns')
      }, /*#__PURE__*/React.createElement("span", null, title), !isStaticMode && (removable !== null && removable !== void 0 ? removable : config.ordinal !== 0) && /*#__PURE__*/React.createElement("span", {
        className: getClassNames('notif-action-remove'),
        onClick: this.handleRemove
      }, (_this$props$removeLab = this.props.removeLabel) !== null && _this$props$removeLab !== void 0 ? _this$props$removeLab : /*#__PURE__*/React.createElement(CloseCircleOutlined, null))), /*#__PURE__*/React.createElement("div", {
        className: getClassNames('notif-action-type')
      }, /*#__PURE__*/React.createElement("span", null, "Action"), /*#__PURE__*/React.createElement(Select, {
        size: "small",
        value: actionType,
        onChange: this.handleActionChange,
        disabled: isStaticMode
      }, /*#__PURE__*/React.createElement(Select.Option, {
        value: NotificationActionType.OPEN_URL
      }, "Open URL"), /*#__PURE__*/React.createElement(Select.Option, {
        value: NotificationActionType.CLOSE,
        disabled: disableCloseSelection
      }, "Dismiss Notification"))), /*#__PURE__*/React.createElement("div", {
        className: getClassNames('notif-action-content')
      }, /*#__PURE__*/React.createElement("div", {
        className: getClassNames('notif-action-label')
      }, /*#__PURE__*/React.createElement("span", null, "Label"), /*#__PURE__*/React.createElement(EmojiManager, null, /*#__PURE__*/React.createElement(MacroManager, {
        types: labelSafeMacroTypes,
        customOptions: this.props.customMacroOptions,
        validOptionTypes: this.props.validMacroOptionTypes
      }, /*#__PURE__*/React.createElement(Input, {
        autoComplete: "off",
        size: "small",
        onChange: this.handleLabelChange,
        disabled: isStaticMode,
        defaultValue: (_this$props$config4 = this.props.config) === null || _this$props$config4 === void 0 ? void 0 : _this$props$config4.label,
        value: labelValue
      })))), actionType === NotificationActionType.OPEN_URL && /*#__PURE__*/React.createElement("div", {
        className: getClassNames('notif-action-landing-url')
      }, !hidePrimaryLandingUrl && /*#__PURE__*/React.createElement("div", {
        className: "switch-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "switch-left"
      }, /*#__PURE__*/React.createElement(Switch, {
        size: "small",
        checked: usePrimaryLandingUrl,
        disabled: isStaticMode || disablePrimaryLandingUrl,
        onChange: this.setUsePrimaryLandingUrl
      })), /*#__PURE__*/React.createElement("div", {
        className: "switch-right"
      }, "Use Primary Landing URL")), (hidePrimaryLandingUrl || !usePrimaryLandingUrl) && /*#__PURE__*/React.createElement(MacroManager, {
        types: macroTypes,
        customOptions: this.props.customMacroOptions,
        validOptionTypes: this.props.validMacroOptionTypes
      }, /*#__PURE__*/React.createElement(Input, {
        size: "small",
        autoComplete: "off",
        placeholder: "https://my.landingpage.domain/my-article",
        defaultValue: landingUrlValue,
        onChange: this.handleLandingUrlChange,
        disabled: isStaticMode
      }))))))));
    }
  }, {
    key: "currentAction",
    get: function get() {
      var _this$props$config5;

      var baseAction = (_this$props$config5 = this.props.config) !== null && _this$props$config5 !== void 0 ? _this$props$config5 : {};
      return NotificationAction.Builder.setType(baseAction.type).setOrdinal(baseAction.ordinal).setLabel(baseAction.label).setUsePrimaryLandingUrl(baseAction.usePrimaryLandingUrl).setLandingUrl(baseAction.landingUrl).setDisplayMeta(baseAction.displayMeta);
    }
  }]);

  return NotificationActionBuilder;
}(React.Component);
export default NotificationActionBuilder;